import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import CartLine from "./CartLine";
import CartShareActions from "./CartShareActions";
import CartTotals from "../components/CartTotals";
import { emptyCart, saveCart } from "../actions/cartActions";
import { Breakpoint } from 'react-socks';
import { withTranslation } from 'react-i18next';
import ExtendedLink from "../components/ExtendedLink";
import ConfirmDialog from "../components/ConfirmDialog";
import { showSuccess, showError } from "../common/iziToast";
import * as Icons from "../common/icons";
import { utils } from "../common/utils";
import SocialShare from "../components/SocialShare";
import { isRequired } from '../common/validators';
import PromotionList from "../components/PromotionList";
import NewWindow from "../components/NewWindow";
import { getCustomerAvailableLoyaltyPointsBalance } from "../actions/loyaltyActions"


class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = { openSaveCartDialog: false, cartName: "",
                        savedCartUrl: null, invalidCartName: false,
                        showShareCartAsDialog: false, showPromotionPopup: false};

        this.onInputchange = this.onInputchange.bind(this);
        this.saveCartAs = this.saveCartAs.bind(this);
        this.onOpenSaveCartAs = this.onOpenSaveCartAs.bind(this);
        this.onCancelSaveCartAs = this.onCancelSaveCartAs.bind(this);
        this.onShowShareCart = this.onShowShareCart.bind(this);
    }

    componentDidMount() {
        const { cart, settings, user, getCustomerAvailableLoyaltyPointsBalance } = this.props;
        if (settings.isLoyaltyProgramFeatureEnabled && user && user.isAuthenticated === true)
            getCustomerAvailableLoyaltyPointsBalance()
    }

    onEmptyCart = e => {
        const { cart, settings } = this.props;
        if (window.gtag) {
            let totalQuantityPrice = cart.lines.reduce(function (accumulator, currentLine) {
                return accumulator + (currentLine.quantity * (currentLine.isLoyaltyPointsUsed ? 0 : currentLine.product.specialPrice));
            }, 0);

            window.gtag('event', 'remove_from_cart', {
                currency: settings.isoCurrencySymbol,
                items: cart.lines.map(line =>
                ({
                    item_id: line.product.stockItemCode,
                    item_name: line.product.title,
                    item_category: line.product.groupName,
                    price: line.product.specialPrice,
                    currency: settings.isoCurrencySymbol,
                    quantity: line.quantity
                })),
                value: totalQuantityPrice
            });
        }

        this.props.emptyCart();
        utils.scrollTop();
    };

    onInputchange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    saveCartAs = () => {
        const { cartName } = this.state;

        if (isRequired(cartName)) {
            this.setState({ invalidCartName: true });
            return false; // disable dialog from closing
        }

        const { t, cart } = this.props;
        this.props.saveCart(cart, true, cartName).then((response) => {

            if (response.value.status === 200) {
                this.setState({ openSaveCartDialog: false, cartName: '', savedCartUrl: response.value.data });
                this.setState({ showShareCartAsDialog: true });

                showSuccess(t("Save Cart"), `${t("Cart successfuly saved")}`, Icons.CART);
            } else {
                showError(t("Remove Cart"), `${t("Unable to save cart. please try again later")}`, Icons.CART);
            }
       }, (error) => {
            showError(t("Remove Cart"), `${t("Unable to save cart. please try again later")}`, Icons.CART);
       });
    }

    onOpenSaveCartAs = e => { this.setState({ openSaveCartDialog: true}) }

    onCancelSaveCartAs = e => {
        this.setState({ openSaveCartDialog: false, invalidCartName: false });
    }

    onCloseShareCartAsDialog = e => { this.setState({ showShareCartAsDialog: false }); }

    onShowShareCart = e => {
        const { t } = this.props;
        const randomCartName = `${t("Share Cart")}_${utils.dates.getDateTimeString(new Date())}`;
        this.setState({ cartName: randomCartName }, this.saveCartAs);
    }

    onOpenPromotion = e => {
        this.setState({ showPromotionPopup: true });
    }

    onClosePromotion = () => {
    this.setState({ showPromotionPopup: false });
    };


    render() {
        const { showPromotionPopup } = this.state;
        const { t, cart, settings, isReadOnly, showCartShareActions, showTotals, selectedCart, user} = this.props;
        if (!cart && !selectedCart) return <div />;

        let toLoadCart = selectedCart ? selectedCart : cart;
        const isEmptyCart = toLoadCart && toLoadCart.lines.length <= 0;

        const showCartManagementActions = user.isAuthenticated && settings.isCustomerCartManagementEnabled && showCartShareActions !== true;
        const actionColumn = isReadOnly ? <Fragment /> : (
            <th className="text-center">
                <button onClick={this.onEmptyCart} className="btn btn-sm btn-outline-danger">
                    {t("Clear Cart")}
                </button>
                {/*
                 <span style={{ padding: "5px" }}></span>
                 <button onClick={this.onOpenPromotion} className={(isEmptyCart ? "btn btn-success disabled-link" : "btn btn-success")} disabled={isEmptyCart}>
                     {t("Promotion")}
                 </button>
                */}
            </th>
        );

        const { openSaveCartDialog, showShareCartAsDialog, invalidCartName, cartName } = this.state;

        const saveCartDialog = (
            <ConfirmDialog title={t("Save Cart")} open={openSaveCartDialog} message="" yesTitle={t("Save")} onYes={this.saveCartAs} noTitle={t("Cancel")} onNo={this.onCancelSaveCartAs}>
                <div className="form-group">
                    <label className='p-0'>{t('Name')}</label> {invalidCartName && <label className='p-0 red'>{t("Please enter a cart name")}</label>}
                    <input className={"form-control form-control-rounded min-input-width" + (invalidCartName ? " has-error" : "")} name="cartName" type="text" placeholder='' value={cartName} onChange={this.onInputchange} />
                </div>
            </ConfirmDialog>
        );

        const shareCartAsDialog = (
            <ConfirmDialog title={t("Share Cart")} open={showShareCartAsDialog} message="" hideNo={true} yesTitle={t("Close")} onYes={this.onCloseShareCartAsDialog}>
                <CartShareActions selectedCart={toLoadCart} />
            </ConfirmDialog>
        );

        const navigationButtons = isReadOnly ? <Fragment />
            : (<Fragment>
                <ExtendedLink to={settings.baseUrl} className="btn btn-outline-primary mr-1">
                {t("Continue Shopping")}
                </ExtendedLink>
                <ExtendedLink to={`${settings.baseUrl}checkout`} className={(isEmptyCart ? "btn btn-success disabled-link" : "btn btn-success")} disabled={isEmptyCart}>
                    {t("Checkout")}
                </ExtendedLink>
            </Fragment>);


        const cartManagementActions = showCartManagementActions ? (
            <Fragment>
                <ExtendedLink to={`${settings.baseUrl}carts`} className="btn btn-sm btn-outline-info mr-1">
                    {t("My Carts")}
                </ExtendedLink>
                <a className='btn btn-sm btn-outline-info mr-1'
                    onClick={this.onOpenSaveCartAs}
                    target="_blank"
                    rel="noopener noreferrer"
                    disabled={isEmptyCart}
                >
                    {t("Save Cart")}
                </a>

                <a className='btn btn-sm btn-outline-info  mr-1'
                    onClick={this.onShowShareCart}
                    target="_blank"
                    rel="noopener noreferrer"
                    disabled={isEmptyCart}
                >
                    {t("Share Cart")}
                </a>
                { utils.isNullOrEmpty(this.state.savedCartUrl) === false && <SocialShare
                    url={`${utils.getWebshopFullUrl(settings)}carts/${this.state.savedCartUrl}`}
                    shape="circle"
                    showTitle={false}
                    displayInline={true}
                    supplierName={settings.supplierName}
                    senderName={user.firstName + ' ' + user.lastName}
                    shareTitle={t('Check this amazing cart')}
                />}
            </Fragment>
        ) : <Fragment />;

        return (
            <Fragment>
                {saveCartDialog}
                {shareCartAsDialog}
                <Breakpoint small down>
                    {!isReadOnly && (
                        <div className="d-flex flex-wrap mb-2 gap-2" style={{ justifyContent: "space-between" }}>
                            <button onClick={this.onEmptyCart} className="btn btn-sm btn-outline-danger">
                                {t("Clear Cart")}
                            </button>
                            {/*<button
                                onClick={this.onOpenPromotion}
                                className={`btn btn-sm btn-success ${isEmptyCart ? "disabled-link" : ""}`}
                                disabled={isEmptyCart}
                            >
                                {t("Promotion")}
                            </button>*/}
                        </div>
                    )}
                    {toLoadCart.lines.map(line => <CartLine
                        //key={line.product.id}
                        key={`${line.product.id}-${line.isPromo}`}
                        line={line}
                        isReadOnly={isReadOnly}
                        isMobile={true}
                    />)}
                    {/* Action buttons for mobile view */}
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        {navigationButtons}
                    </div>
                    {cartManagementActions}
                    {showCartShareActions &&  <CartShareActions selectedCart={toLoadCart} /> }
                </Breakpoint>
                <Breakpoint medium up>
                    <div className="table-responsive shopping-cart">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>{t("Product Name")}</th>
                                    <th className="text-center">{t("Quantity")}</th>
                                    <th className="text-center">{t("Unit Price")}</th>
                                    <th className="text-center">{t("Total")}</th>
                                    {settings.isLoyaltyProgramFeatureEnabled && user && user.isAuthenticated === true
                                     && <th className="text-center">{t("Loyalty Points")}</th>}
                                    {actionColumn}
                                </tr>
                            </thead>
                            <tbody>
                                {toLoadCart.lines.map(line => <CartLine
                                    //key={line.product.id}
                                    key={`${line.product.id}-${line.isPromo}`}
                                    line={line}
                                    isReadOnly={isReadOnly}
                                />)}
                            </tbody>
                            <tfoot>
                                {showTotals === true &&  <tr>
                                    <td> </td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center">
                                       <CartTotals cart={cart} settings={settings} showTitle={false} />
                                    </td>
                                </tr>}
                                {isReadOnly !== true && <tr>
                                    <td colSpan={(settings.isLoyaltyProgramFeatureEnabled && user && user.isAuthenticated === true) ? 5 : 4}>
                                        {cartManagementActions}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {navigationButtons}
                                    </td>

                                </tr>}
                                {showCartShareActions && <tr>
                                    <td colSpan={4} className="text-center">
                                        <CartShareActions selectedCart={toLoadCart} />
                                    </td>
                                </tr>}

                            </tfoot>
                        </table>
                    </div>
                </Breakpoint>

               {showPromotionPopup && (
                <NewWindow
                    open={showPromotionPopup}
                    onClose={this.onClosePromotion}
                    title={t("Promotion")}
                    fitContent={true}
                    customModalClass="promotion-modal"
                    blockScroll={false}
                >
                    <PromotionList />
                </NewWindow>
                )}
            </Fragment>
        );
    }
}

function mapStateToProps({ cart, wishList, settings, user }, ownProps) {
    return { cart, wishList, settings, user, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, { emptyCart, saveCart, getCustomerAvailableLoyaltyPointsBalance })(Cart));
